import React, { useEffect, useState } from "react";
import LoadingButton from "../../elements/LoadingButton";
import MAlert from "../../elements/MAlert";
import {
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  TextField,
  Checkbox,
  FormControlLabel,
  CardActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box,
  LinearProgress,
  Grid,
  FormLabel,
  RadioGroup,
  Radio,
  IconButton,
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import * as yup from "yup";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { DrugSubCategoryService } from "../../../services/DrugSubCategoryService";
import { DrugTypeService } from "../../../services/DrugTypeService";
import { DrugBrandService } from "../../../services/DrugBrandService";
import { AgeGroupService } from "../../../services/AgeGroupService";
import { DrugUnitService } from "../../../services/DrugUnitService";
import Chip from "@material-ui/core/Chip";
import Autocomplete from "@material-ui/lab/Autocomplete";
import NumberTextField from "./../../elements/NumberTextField";
import { DrugService } from "../../../services/DrugService";
import DrugSpecification from "./DrugSpecification";
import DrugSale from "./DrugSale";
import { Formik, FormikProvider, useFormik } from "formik";
import { values } from "underscore";
const useStyle = makeStyles((theme) => ({
  red: {
    color: "red",
  },
  box: {
    marginTop: theme.spacing(4),
  },
}));

const NewDrug = () => {
  const theme = useTheme();
  const classes = useStyle();

  const [types, setTypes] = useState([]);
  const [brands, setBrands] = useState([]);
  const [ageGroups, setAgeGroups] = useState([]);
  //const [units , setUnits] =useState([])
  const [images, setImages] = useState([]);
  const [files, setFiles] = useState([]);
  const [gender, setGender] = useState("Male");
  const [selectedAgeGroups, setSelectedAgeGroups] = useState([]);
  //const [selectedUnits , setSelectedUnits] = useState([])
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [fixedSubCategory, setFixedSubCategory] = useState([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [isPrescription, setIsPrescription] = useState(false);
  const [status, setStatus] = useState(true);
  const [type, setType] = useState(null);
  const [alert, setAlert] = useState({
    show: false,
    message: null,
    type: null,
  });
  const [uploading, setUploading] = useState({
    isDisplay: false,
    progress: 0,
  });
  const [loading, setLoading] = useState(false);

  const Schema = yup.object().shape({
    name: yup.string().required("Medicine name is required"),
    formula: yup.string().required("Medicine formula is required"),
    description: yup.string().required("Medicine description is required"),
    measurement: yup.string(),
    price: yup
      .number()
      .positive("price must be greater than zero")
      .required("quantity is required"),
    salePrice: yup.number(),
    code: yup.number(),
    packSize: yup
      .number()
      .positive("Pack size must be greater than zero")
      .required("Pack size is required"),
    stripSize: yup
      .number()
      .positive("Strip size must be greater than zero")
      .required("Strip size is required"),
    manufactureDate: yup.date(),
    expiryDate: yup.date(),
    drugSales: yup.array().of(
      yup.object().shape({
        title: yup.string().required("Drug sale type title is required"),
        price: yup.number().required("Drug price is required"),
        salePrice: yup
          .number()
          .positive("Sale price must be greater than zero"),
      })
    ),
    dataSpecifications: yup.array().of(
      yup.object().shape({
        title: yup.string().required("Title is required"),
        description: yup.string().required("Description is required"),
      })
    ),
  });

  const initialValues = {
    name: "",
    formula: "",
    description: "",
    measurement: "",
    price: 0,
    salePrice: 0,
    code: 0,
    packSize: 0,
    stripSize: 0,
    manufactureDate: new Date(),
    expiryDate: new Date(),
    drugSales: [],
    specifications: [],
  };

  useEffect(() => {
    DrugSubCategoryService.findAll().then((res) => {
      setFixedSubCategory([res.response[0], ...fixedSubCategory]);
      setSelectedSubCategories([
        ...[res.response[0]],
        ...selectedSubCategories,
      ]);
      setSubCategories(res.response);
    });
  }, []);

  useEffect(() => {
    DrugTypeService.findAll().then((res) => {
      if ((res.response || []).length > 0) setType(res.response[0].title);
      setTypes(res.response);
    });
  }, []);
  useEffect(() => {
    DrugBrandService.findAll().then((res) => setBrands(res.response));
  }, []);
  useEffect(() => {
    AgeGroupService.findAll().then((res) => setAgeGroups(res.response));
  }, []);

  useEffect(() => {
    let mFiles = [];
    for (var i = 0; i < images.length; i++)
      mFiles.push(URL.createObjectURL(images[i]));
    console.log(images);
    setFiles(mFiles);
    console.log("image render");
    //setFiles(images.map(image=> URL.createObjectURL(image)))
  }, [images]);

  const onUploadProgress = (progressEvent) => {
    const { loaded, total } = progressEvent;
    let percent = Math.floor((loaded * 100) / total);
    setUploading({
      ...uploading,
      progress: percent,
    });
    if (percent === 100) {
      setTimeout(() => {
        setUploading({
          ...uploading,
          isDisplay: false,
          progress: 0,
        });
      }, 1000);
    }
  };

  const onSubmit = (data) => {
    var discount = 0.0;
    // if (data.salePrice > 0 && data.salePrice <= data.price) {
    //   discount = ((data.price - data.salePrice) / data.price) * 100;
    // }
    data.drugSales = data.drugSales.map((sale) => ({
      title: sale.title,
      price: sale.price,
      discount: ((sale.price - sale.salePrice) / sale.price) * 100,
    }));

    let drug = {
      DrugTypeId: types.find(
        (t) => t.title.toLowerCase() === type.toLowerCase()
      ).id,
      brands: selectedBrands,
      subCategories: selectedSubCategories,
      ageGroups: selectedAgeGroups,
      status: status,
      isPrescription: isPrescription,
      measurement: data.measurement,
      price: data.price,
      discount: discount,
      name: data.name,
      formula: data.formula,
      description: data.description,
      code: data.code,
      images: images,
      gender: gender,
      packSize: data.packSize,
      stripSize: data.stripSize,
      DrugSpecifications: data.specifications,
      DrugSales: data.drugSales,
      manufactureDate: data.manufactureDate,
      expiryDate: data.expiryDate,
    };

    DrugService.save(drug, onUploadProgress)
      .then((res) => {
        console.log(res);
        setLoading(false);
        resetForm();
        setAlert({
          show: true,
          message: res.message,
          type: "success",
        });
      })
      .catch((error) => {
        setLoading(false);
        setUploading({
          ...uploading,
          percent: 0,
          isDisplay: false,
        });
        setAlert({
          show: true,
          message: error.message,
          type: "error",
        });
      });
  };

  const resetForm = () => {};

  //   const onRemoveDrugSale = (index) => {
  //     let sp = drugSales.filter((value) => value.index != index);
  //     setDrugSales(sp);
  //     dataDrugSales = dataDrugSales.filter((value) => value.index != index);
  //   };

  const onRemoveDrugSale = (values, setValues, index) => {
    const drugSales = [...values.drugSales];
    const newDrugSales = drugSales
      .slice(0, index)
      .concat(drugSales.slice(index + 1, drugSales.length));
    setValues({ ...values, drugSales: newDrugSales }, false);
  };
  const addNewDrugSale = (values, setValues) => {
    setValues(
      {
        ...values,
        drugSales: [...values.drugSales, { title: "", price: 0, salePrice: 0 }],
      },
      false
    );
  };

  const onRemoveDrugSpecification = (values, setValues, index) => {
    const specifications = [...values.specifications];
    const newSpecifications = specifications
      .slice(0, index)
      .concat(specifications.slice(index + 1, specifications.length));
    setValues({ ...values, specifications: newSpecifications }, false);
  };
  const addNewDrugSpecification = (values, setValues) => {
    setValues(
      {
        ...values,
        specifications: [
          ...values.specifications,
          { title: "", description: "" },
        ],
      },
      false
    );
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={Schema}
      onSubmit={onSubmit}
    >
      {(props) => {
        const {
          errors,
          values,
          touched,
          setValues,
          handleBlur,
          handleChange,
          setFieldValue,
          handleSubmit,
        } = props;

        return (
          <form onSubmit={handleSubmit} noValidate>
            <Card>
              <MAlert alert={alert} setAlert={setAlert} />
              <CardHeader title="New Drug" />
              <CardContent>
                <Grid spacing={4} container>
                  <Grid item xs={12} sm={12} md={4}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          margin="normal"
                          required
                          id="code"
                          label="Code"
                          name="code"
                          autoComplete="code"
                          value={values.code}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          margin="normal"
                          required
                          id="measurement"
                          label="Measurement"
                          name="measurement"
                          autoComplete="measurement"
                          value={values.measurement}
                          onChange={handleChange}
                        />
                      </Grid>
                    </Grid>

                    <TextField
                      error={errors.name && touched.name ? true : false}
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="name"
                      label="Medicine Name"
                      name="name"
                      autoComplete="name"
                      helperText={errors.name}
                      value={values.name}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />

                    <TextField
                      error={errors.formula && touched.formula ? true : false}
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="formula"
                      label="Medicine formula"
                      name="formula"
                      autoComplete="formula"
                      helperText={errors.formula}
                      value={values.formula}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />

                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={6}>
                        <TextField
                          helperText={errors.packSize}
                          error={
                            errors.packSize && touched.packSize ? true : false
                          }
                          fullWidth
                          variant="outlined"
                          margin="normal"
                          required
                          id="packSize"
                          label="Pack Size"
                          name="packSize"
                          autoComplete="packSize"
                          value={values.packSize}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          helperText={errors.stripSize}
                          error={
                            errors.stripSize && touched.stripSize ? true : false
                          }
                          variant="outlined"
                          margin="normal"
                          required
                          id="stripSize"
                          label="Strip Size"
                          name="stripSize"
                          autoComplete="stripSize"
                          value={values.stripSize}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                    </Grid>

                    <TextField
                      error={errors.price && touched.price ? true : false}
                      helperText={errors.price}
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      label="Price/Tablet/Syrup"
                      id="price"
                      name="price"
                      autoComplete="price"
                      value={values.price}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                    {/* <TextField
                      error={
                        formik.errors.salePrice && formik.touched.salePrice
                          ? true
                          : false
                      }
                      helperText={formik.errors.salePrice}
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      label="Sale Price"
                      id="salePrice"
                      name="salePrice"
                      autoComplete="salePrice"
                      {...formik.getFieldProps("salePrice")}
                    /> */}

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={status}
                          onChange={(event) => setStatus(!status)}
                          name="status"
                          id="status"
                        />
                      }
                      label="Status"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isPrescription}
                          onChange={(event) =>
                            setIsPrescription(!isPrescription)
                          }
                          name="isPrescription"
                          id="isPrescription"
                        />
                      }
                      label="Medicine requires prescription "
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4}>
                    <FormControl fullWidth variant="outlined" margin="normal">
                      <InputLabel id="type">Drug Type</InputLabel>
                      <Select
                        error={type === null}
                        name="type"
                        value={type}
                        onChange={(event) => setType(event.target.value)}
                        required
                        labelId="demo-simple-select-outlined-label"
                        id="type"
                        label="type"
                      >
                        {types.map((type) => (
                          <MenuItem value={type.title}>{type.title}</MenuItem>
                        ))}
                      </Select>
                      <FormHelperText className={classes.red}>
                        {type === null ? `Select drug type required` : ``}
                      </FormHelperText>
                    </FormControl>

                    <FormControl fullWidth margin="normal" variant="outlined">
                      <Autocomplete
                        multiple
                        id="fixed-tags-demo"
                        value={selectedBrands}
                        onChange={(event, newValue) => {
                          setSelectedBrands([
                            ...newValue.filter((option) => option),
                          ]);
                        }}
                        options={brands}
                        getOptionLabel={(option) => option.title}
                        renderTags={(tagValue, getTagProps) =>
                          tagValue.map((option, index) => (
                            <Chip
                              label={option.title}
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                        style={{ width: 500 }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select brands"
                            variant="outlined"
                            placeholder="Brands"
                          />
                        )}
                      />
                    </FormControl>

                    <FormControl fullWidth margin="normal" variant="outlined">
                      <Autocomplete
                        multiple
                        id="fixed-tags-demo"
                        value={selectedSubCategories}
                        onChange={(event, newValue) => {
                          setSelectedSubCategories([
                            ...fixedSubCategory,
                            ...newValue.filter(
                              (option) =>
                                fixedSubCategory.indexOf(option) === -1
                            ),
                          ]);
                        }}
                        options={subCategories}
                        getOptionLabel={(option) => option.title}
                        renderTags={(tagValue, getTagProps) =>
                          tagValue.map((option, index) => (
                            <Chip
                              label={option.title}
                              {...getTagProps({ index })}
                              disabled={fixedSubCategory.indexOf(option) !== -1}
                            />
                          ))
                        }
                        style={{ width: 500 }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Add in categories"
                            variant="outlined"
                            placeholder="Category"
                          />
                        )}
                      />
                    </FormControl>

                    <FormControl fullWidth margin="normal" variant="outlined">
                      <Autocomplete
                        multiple
                        id="fixed-tags-demo"
                        value={selectedAgeGroups}
                        onChange={(event, newValue) => {
                          setSelectedAgeGroups([
                            ...newValue.filter((option) => option),
                          ]);
                        }}
                        options={ageGroups}
                        getOptionLabel={(option) => option.groupName}
                        renderTags={(tagValue, getTagProps) =>
                          tagValue.map((option, index) => (
                            <Chip
                              label={option.groupName}
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                        style={{ width: 500 }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select age groups"
                            variant="outlined"
                            placeholder="Age Group"
                          />
                        )}
                      />
                    </FormControl>

                    <FormControl component="fieldset">
                      <FormLabel component="legend">Gender</FormLabel>
                      <RadioGroup
                        aria-label="gender"
                        name="gender"
                        value={gender}
                        onChange={(event) => setGender(event.target.value)}
                      >
                        <FormControlLabel
                          value="Female"
                          control={<Radio />}
                          label="Female"
                        />
                        <FormControlLabel
                          value="Male"
                          control={<Radio />}
                          label="Male"
                        />
                        <FormControlLabel
                          value="Both"
                          control={<Radio />}
                          label="Both"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4}>
                    <TextField
                      multiline
                      rows={4}
                      error={
                        errors.description && touched.description ? true : false
                      }
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="description"
                      label="Description"
                      name="description"
                      autoComplete="description"
                      helperText={errors.description}
                      value={values.description}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />

                    <input
                      type="file"
                      name="images"
                      id="images"
                      onChange={(event) => setImages(event.target.files)}
                      multiple
                    />
                    <Grid container>
                      {files.map((file) => (
                        <Grid item xs={12} sm={12} md={4}>
                          <img src={file} width="100" />
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>

                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => addNewDrugSale(values, setValues)}
                  >
                    Add Drug Sale Type
                  </Button>

                  <Grid container spacing={2}>
                    {values.drugSales.map((drugSale, index) => {
                      const err =
                        (errors.drugSales?.length && errors.drugSales[index]) ||
                        {};
                      const touch =
                        (touched.drugSales?.length &&
                          touched.drugSales[index]) ||
                        {};

                      const name = `drugSales.${index}`;
                      return (
                        <Grid item xs={12} sm={12} md={3}>
                          <Card>
                            <CardHeader
                              action={
                                <IconButton
                                  onClick={(event) =>
                                    onRemoveDrugSale(values, setValues, index)
                                  }
                                  aria-controls="filter-menu"
                                  aria-haspopup="true"
                                >
                                  <CancelIcon />
                                </IconButton>
                              }
                            />
                            <CardContent>
                              <TextField
                                onChange={handleChange(`${name}.title`)}
                                value={drugSale.title}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id={`title`}
                                label="Title"
                                placeholder="Sale Type"
                                name={`title`}
                                autoComplete={`title`}
                                error={err.title && touch.title ? true : false}
                                helperText={err.title}
                              />
                              <TextField
                                onChange={handleChange(`${name}.price`)}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                placeholder="Price"
                                id={`price`}
                                label="Price"
                                name={`price`}
                                autoComplete={`Price`}
                                value={drugSale.price}
                                error={err.price && touch.price ? true : false}
                                helperText={err.price}
                              />
                              <TextField
                                onChange={handleChange(`${name}.salePrice`)}
                                value={drugSale.salePrice}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                placeholder="Sale Price"
                                id={`salePrice`}
                                label="Sale Price"
                                name={`salePrice`}
                                autoComplete={`salePrice`}
                                helperText={err.salePrice}
                                error={
                                  err.salePrice && touch.salePrice
                                    ? true
                                    : false
                                }
                              />
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    })}
                  </Grid>
                  <br />
                  <br />

                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => addNewDrugSpecification(values, setValues)}
                  >
                    Add Drug Specification
                  </Button>
                  <Grid container spacing={2}>
                    {values.specifications.map((specification, index) => {
                      const err =
                        (errors.specifications?.length &&
                          errors.specifications[index]) ||
                        {};
                      const touch =
                        (touched.specifications?.length &&
                          touched.specifications[index]) ||
                        {};

                      const name = `specifications.${index}`;
                      return (
                        <Grid item xs={12} sm={12} md={3}>
                          <Card>
                            <CardHeader
                              action={
                                <IconButton
                                  onClick={(event) =>
                                    onRemoveDrugSpecification(
                                      values,
                                      setValues,
                                      index
                                    )
                                  }
                                  aria-controls="filter-menu"
                                  aria-haspopup="true"
                                >
                                  <CancelIcon />
                                </IconButton>
                              }
                            />
                            <CardContent>
                              <TextField
                                onChange={handleChange(`${name}.title`)}
                                value={specification.title}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id={`title`}
                                label="Title"
                                placeholder="Title"
                                name={`title`}
                                autoComplete={`title`}
                                error={err.title && touch.title ? true : false}
                                helperText={err.title}
                              />
                              <TextField
                                multiline
                                rows={2}
                                onChange={handleChange(`${name}.description`)}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                placeholder="Description"
                                id={`description`}
                                label="Description"
                                name={`description`}
                                autoComplete={`description`}
                                value={specification.description}
                                error={
                                  err.description && touch.description
                                    ? true
                                    : false
                                }
                                helperText={err.description}
                              />
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  type="reset"
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  type="submit"
                >
                  Save
                </Button>
              </CardActions>
              <LinearProgress
                style={{ display: uploading.isDisplay ? "block" : "none" }}
                variant="determinate"
                value={uploading.progress}
              />
            </Card>
          </form>
        );
      }}
    </Formik>
  );
};

export default NewDrug;
